import { atom, selector } from 'recoil';
import { ValueLabelResponse } from 'types';
import { UpdateAdminUserRequest } from 'api';

export const manageOrganisationUserTableEditingRowState = atom<number | undefined>({
  key: 'manageOrganisationUserTableEditingRow',
  default: undefined,
});

export const manageOrganisationUserTableNameInputState = atom<string>({
  key: 'manageOrganisationUserTableNameInput',
  default: '',
});

export const manageOrganisationUserTableEmailInputState = atom<string>({
  key: 'manageOrganisationUserTableEmailInput',
  default: '',
});

export const manageOrganisationUserTablePermissionState = atom<number>({
  key: 'manageOrganisationUserTablePermission',
  default: 0,
});

export const manageOrganisationUserTableTeamsState = atom<ValueLabelResponse[]>({
  key: 'manageOrganisationUserTableTeams',
  default: [],
});

export const manageOrganisationUserTableIsRegisteredState = atom<string>({
  key: 'manageOrganisationUserTableIsRegistered',
  default: 'false',
});

export const manageOrganisationUserTableRequestState = selector<UpdateAdminUserRequest>({
  key: 'manageOrganisationUserTableRequest',
  get: ({ get }) => {
    return {
      userName: get(manageOrganisationUserTableNameInputState),
      teams: get(manageOrganisationUserTableTeamsState).map((team) => team.value),
      permissionId: get(manageOrganisationUserTablePermissionState),
      isRegistered: get(manageOrganisationUserTableIsRegisteredState) === 'true',
    } as unknown as UpdateAdminUserRequest;
  },
});
